document.addEventListener("DOMContentLoaded", function () {
  const main_product = document.querySelector(".main-product");
  const is_bundled = main_product?.dataset?.is_bundled?.trim() == "true";

  if (is_bundled) {
    const productData = main_product.querySelector("[bundled-variant-data]")?.innerHTML;
    const swatches = document.querySelectorAll(".bundled-option");

    const parsedProductData = productData ? JSON.parse(productData) : {};

    const UpdateProductImage = (updated_image, position) => {
      const primary_image = main_product.querySelectorAll(".bundled-image")[position];
      if (primary_image && updated_image) {
        primary_image.src = updated_image;
      }
    };

    const UpdateProductDescription = (updated_short_description, size, position) => {
      const short_description = main_product.querySelectorAll(".product-bundle-description")[position];

      if (short_description && updated_short_description) {
        if (size) {
          short_description.innerHTML = `${updated_short_description} ● ${size}`;
        } else {
          short_description.innerHTML = updated_short_description;
        }
      } else {
        short_description.innerHTML = "";
      }
    };

    const UpdateHudaShade = (isHudaShade, position) => {
      const hudaShadeContainer = main_product.querySelectorAll(".hudas-badge")[position];
      if (hudaShadeContainer) {
        if (isHudaShade) {
          hudaShadeContainer.classList.remove("hide");
        } else {
          hudaShadeContainer.classList.add("hide");
        }
      }
    };

    const UpdateAddToBagStatus = (isAvailable) => {
      const add_to_bag = main_product.querySelector(".product-form__submit");
      if (add_to_bag) {
        if (isAvailable) {
          add_to_bag.removeAttribute("disabled");
          if (add_to_bag?.hasAttribute('preorder')) {
            add_to_bag.textContent = 'Pre-Order';
          }
        } else {
          add_to_bag.setAttribute("disabled", isAvailable);
          if (add_to_bag?.hasAttribute('preorder')) {
            add_to_bag.textContent = 'Out Of Stock';
          }
        }
      }
    };

    const updateStickyAddToBag = (isAvailable) => {
      const add_to_bag = document.querySelector(".add-to-cart-panel .product-form__submit");
      const sticky_add_to_bag = document.querySelector(".sticky-atc-mobile .product-form__submit")

      if (add_to_bag) {
        if (isAvailable) {
          add_to_bag.removeAttribute("disabled");
          sticky_add_to_bag.removeAttribute("disabled");
          if (add_to_bag?.hasAttribute('preorder')) {
            add_to_bag.textContent = 'Pre-Order';
            sticky_add_to_bag.textContent = 'Pre-Order';
          }
        } else {
          add_to_bag.setAttribute("disabled", isAvailable);
          sticky_add_to_bag.setAttribute("disabled", isAvailable);
          if (add_to_bag?.hasAttribute('preorder')) {
            add_to_bag.textContent = 'Out Of Stock';
            sticky_add_to_bag.textContent = 'Out Of Stock';
          }
        }
      }
    };

    const UpdateProductPrice = (updated_price, updated_compare_at_price, updated_save_price) => {
      const price_elements = main_product.querySelectorAll(".product-price");
      const compare_at_price = main_product.querySelector(".product-compare-at-price");
      const save_price = main_product.querySelector(".product-save-price");

      price_elements.forEach((price_element) => {
        price_element.innerHTML = updated_price;
      });

      compare_at_price.innerHTML = updated_compare_at_price;
      save_price.innerHTML = updated_save_price;
    };

    swatches?.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        let selected_variant_id_input = main_product.querySelector(".selected-variant-id");

        const variant = parsedProductData.variants.find((item) => item.id == swatch.dataset.id);

        const selected_option_name = Array.from(main_product.querySelectorAll(".selected-bundle-option"));
        const selected_swatch_id = main_product.querySelector(".product-variant-id");
        const selected_swatch_id_sticky = document.querySelector(".add-to-cart-panel .product-variant-id");

        if (variant) {
          const position = parseInt(swatch.dataset.position);
          const short_description = variant?.metafields?.custom?.shortDescription;
          const size = variant?.metafields?.custom?.size;
          const isHudaShade = variant?.metafields?.custom?.isHudaShade;
          const image_url = variant?.metafields?.custom?.image_url;
          const option = variant?.options[0];
          if (selected_option_name[position]) {
            selected_option_name[position].value = option;
          }
          const filtered_options = Array.from(selected_option_name)
            .filter((option) => !option.classList.contains("single-product"))
            .map((option) => option.value.trim());

          const selected_variant = parsedProductData.bundle_variants.find((inner_variant) => {
            const inner_options = (inner_variant.options || []).map((opt) => opt.trim());
            return (
              inner_options.length === filtered_options.length &&
              inner_options.every((option, index) => option === filtered_options[index])
            );
          });

          if (selected_variant) {
            selected_variant_id_input.value = selected_variant.id;
            const url = new URL(window.location.href);
            url.searchParams.set("variant", selected_variant.id);
            window.history.replaceState({}, "", url);

            if (selected_swatch_id) {
              selected_swatch_id.value = selected_variant.id;
            }
            if (selected_swatch_id_sticky) {
              selected_swatch_id_sticky.value = selected_variant.id;
            }

            // Call Functions
            UpdateProductImage(image_url, position);
            UpdateProductDescription(short_description, size, position);
            UpdateHudaShade(isHudaShade, position);
            UpdateAddToBagStatus(selected_variant.available);
            updateStickyAddToBag(selected_variant.available);
            UpdateProductPrice(selected_variant.price, selected_variant.compare_at_price, selected_variant.save_price);
            updateQuantityRoles(main_product, selected_variant, swatch.dataset.quantityInCart, swatch);
            try {
              document.dispatchEvent(
                new CustomEvent("pdp-inline-quantity:sync", {
                  detail: { variantId: selected_variant.id },
                }),
              );
            } catch (e) {}
          }
        }
      });
    });
  }
});
